import { render, staticRenderFns } from "./dlvmain.vue?vue&type=template&id=9f05a414&scoped=true"
import script from "./dlvmain.vue?vue&type=script&lang=js"
export * from "./dlvmain.vue?vue&type=script&lang=js"
import style0 from "./dlvmain.vue?vue&type=style&index=0&id=9f05a414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f05a414",
  null
  
)

export default component.exports